/** Verb ids for `/api/lrs/report` — align with backend xAPI verb segment */
const verbsTypes = {
    ENTER: "enter",
    EXIT: "exit",
};

export default verbsTypes;
